import Api from '@/services/Api'

export default {
  getPublic (params) {
    if (params.search) {
      return Api().get(`items?p=${params.page}&search=${params.search}`)
    } else if (params.find) {
      return Api().get(`items?p=${params.page}&find=${params.find}`)
    } else if (params.page) {
      return Api().get(`items?p=${params.page}`)
    } else {
      return Api().get('items')
    }
  },
  getPrivate (info, params) {
    if (params) {
      return Api().post(`items/private?search=${params}`, info)
    } else {
      return Api().post('items/private', info)
    }
  },
  getAll (info, params) {
    if (params) {
      return Api().post(`items/all?search=${params}`, info)
    } else {
      return Api().post('items/all', info)
    }
  },
  search (info) {
    return Api().get(`items?search=${info}`)
  },
  add (info) {
    return Api().post('items', info)
  },
  delete (info) {
    return Api().post('items/delete', info)
  },
  getTemplates () {
    return Api().get('items/templates')
  },
  getUserCreated (info) {
    return Api().post('items/user', info)
  },
  override (info) {
    return Api().post('items/override', info)
  },
  getChipCount (info) {
    return Api().post('items/count', info)
  }
}
